import React from "react";
import { Typography, Chip, Container, Box } from "@mui/material";
import SearchInput from "./searchInput/SearchInput";
import Infinity from "../../../../assets/images/infinity.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setPortalInfo } from "../../../../redux/globalSlice";

const HeaderSection = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const portal = localStorage.getItem("portal");

  const handleChipsClick = (portalName, portalValue) => {
    dispatch(
      setPortalInfo({
        portalName: portalName,
        portalValue: portalValue,
      })
    );
    navigate("/signup");
  };

  return (
    <section className={"section"}>
      <Box className="infinityBackground">
        <img src={Infinity} alt="infinity_image" />
      </Box>
      <Container>
        <Typography variant="h4" className={"heading"}>
          Drive Your Success With Us!
        </Typography>
        <Typography className={"subheading"}>
          5 lakh+ jobs for you to explore
        </Typography>
        <SearchInput />
        <div className="chips">
          {(!token || (token && portal === "Jobseeker")) && (
            <Chip
              label="I am fresher, looking for job"
              className={"chip"}
              onClick={() => handleChipsClick("Jobseeker", "jobseeker")}
            />
          )}
          {(!token || (token && portal === "Employer")) && (
            <Chip
              // label="I am professional, looking for a change"
              label="I aim to expand my organisation"
              className={"chip"}
              onClick={() => handleChipsClick("Employer", "employer")}
            />
          )}
          {(!token || (token && portal == "Freelancer")) && (
            <Chip
              label="I want to earn money"
              className={"chip"}
              onClick={() => handleChipsClick("Freelancer", "freelancer")}
            />
          )}
          {/* Add more chips as needed */}
        </div>
      </Container>
    </section>
  );
};

export default HeaderSection;
